<template>
  <v-progress-linear
      indeterminate
      v-if="loading"
      :height="height ? height : 5"
      :color="color ? color : 'blue darken-2'"
  ></v-progress-linear>
</template>

<script>
export default {
  name: "Loading",
  props: ["loading", "color", "height"]
}
</script>

<style scoped>

</style>